
define('app/board/views/selectPlayerView',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/collections/pickCollection',
	'known/models/leagueInstanceModel',
	'app/board/models/draftStatusModel',
	'app/board/models/positionColorsModel',
	'app/board/views/selectPlayerEntryView',
	'app/board/util/playerList'
], function($, _, Backbone, PickCollection, LeagueInstanceModel, DraftStatusModel, PositionColorsModel, SelectPlayerEntryView, PlayerList){
	var SelectManualPlayerView = Backbone.View.extend({
		initialize: function(options) {
			this.event = options.event;
			this.pickCollection = options.pickCollection;
			this.pickSummaryCollection = options.pickSummaryCollection;
			this.leagueInstance = options.leagueInstance;
			this.draftStatus = options.draftStatus;
			this.sportsTeams = options.sportsTeams;
			
			this.addedPickSumId = 1001;
			this.submittedData = {isSubmitted : false};
			
			_.bindAll(this, 'returnToMain');
			_.bindAll(this, 'submitNewPlayerPick');
			_.bindAll(this, 'updatePickSumId');
			_.bindAll(this, 'successCallback');
			_.bindAll(this, 'errorCallback');
			
			
			$("#draftPlayerManualBack").on("click", this.returnToMain);
			$("#draftPlayerManualFormFooterBtn").on("click", this.submitNewPlayerPick);
			
			$(document).on('draftApp:addPickSum', this.updatePickSumId);
			
			this.listenTo(this.event, 'error', this.error);
			
			//Error handling
			this.listenTo(this.event, 'error:position', this.errorPos);
			this.listenTo(this.event, 'error:lastname', this.errorLastName);
			this.listenTo(this.event, 'error:firstname', this.errorFirstName);
			this.listenTo(this.event, 'error:teamabbr', this.errorTeamAbbr);
			
			this.render();
		},
		
		submitNewPlayerPick: function(event) {
			event.preventDefault();			
			
			if(!this.submittedData.isSubmitted) {
				this.submittedData.isSubmitted = true;
				this.processing();
				var round = this.draftStatus.get('round');
				var posInRound = this.draftStatus.get('posInRound');
				var fantTeamId = this.draftStatus.get('draftingTeamId');
				var keeper = false;
				var autoDrafted = false;
				
				var pickSum = this.pickSummaryCollection.get(this.pickSummaryCollection.getPosRoundId(this.draftStatus.get('round'), this.draftStatus.get('posInRound')));
				var value = 0;
				
				if(this.leagueInstance.get('draftStatus') == 'PREDRAFT'){
					pickSum = this.pickSummaryCollection.get(this.addedPickSumId);
					round = pickSum.get('round')
					posInRound = pickSum.get('posInRound');
					fantTeamId = pickSum.get('fantasyTeamId');
					keeper = true;
				}
				
				//Nominating Player
				//if(this.leagueInstance.get('draftType') == 'AUCTION') {
				//	value = 0;
				//}
				
				if(this.leagueInstance.get('draftType') == 'AUCTION') {
					var valueInput = $('#draftPlayerManualBidInput').val();
					var numPattern = new RegExp("^[0-9]*$");
					
					if(!valueInput){
						valueInput = 1;
					} else if(valueInput && valueInput.length == 0){
						valueInput = 1; 
					} else if(!valueInput.match(numPattern)){
						$('#draftPlayerManualBidErrMsg').html("Bid field may only contain numbers");
						$('#draftPlayerManualBidInput').addClass("error");
						$('#draftPlayerManualBidErrMsg').show();
						return this;
					} else {
						valueInput = parseInt(valueInput);
					}				
					
					var curBudget = this.draftStatus.get('teamBudget')[fantTeamId];
					var playersPicked = this.draftStatus.get('teamPickCount')[fantTeamId];
					var maxPlayers = this.draftStatus.get('teamMaxNumPicks')[fantTeamId];
					var maxBid = curBudget-(maxPlayers-playersPicked)+1;
					
					if(valueInput > maxBid) {
						$('#draftPlayerManualBidErrMsg').html("Bid is higher then max bid");
						$('#draftPlayerManualBidInput').addClass("error");
						$('#draftPlayerManualBidErrMsg').show();
						return this;
					} else if(valueInput < 1){
						$('#draftPlayerManualBidErrMsg').html("Bid must be at least 1");
						$('#draftPlayerManualBidInput').addClass("error");
						$('#draftPlayerManualBidErrMsg').show();
						return this;
					} else if(valueInput > 999) {
						$('#draftPlayerManualBidErrMsg').html("Bid must be less then 1000");
						$('#draftPlayerManualBidInput').addClass("error");
						$('#draftPlayerManualBidErrMsg').show();
						return this;
					}
					
					value = valueInput;
				}
				
				var dataObj = {
						firstName: this.$el.find("#draftPlayerManualFirstNameInput").val().trim(),
						lastName: this.$el.find("#draftPlayerManualLastNameInput").val().trim(),
						teamAbbr: this.$el.find("#draftPlayerManualFormTeamSelectContainer").find('.draftPlayerManualInputSelect').val(),
						position: this.$el.find("#draftPlayerManualFormPosSelectContainer").find('.draftPlayerManualInputSelect').val(),
						fantasyTeamId: fantTeamId,
						value: value,
						round: round,
						posInRound: posInRound,
						keeper: keeper};
				
				$.ajax({
					headers : {
						"Content-Type" : "application/json",
						"Accept" : "application/json"
					},
					url : '/draftapp/leagues/' 
						+ this.leagueInstance.get('leagueId') 
						+ '/league-instances/' 
						+ this.leagueInstance.get('id')
						+ '/picks/new',
					type : 'POST',
					dataType : 'json',
					//accepts: 'application/json',
					//contentType: 'application/json',
					data : JSON.stringify(dataObj, null, 2),
					success: this.successCallback,
					error: this.errorCallback
				});
			}
		},
		
		successCallback: function() {
			if(this.submittedData.isSubmitted){
				this.submittedData.isSubmitted = false;
				this.showForm();
				this.$el.find("#draftPlayerManualFirstNameInput").val(''),
				this.$el.find("#draftPlayerManualLastNameInput").val(''),
				this.$el.find("#draftPlayerManualFormTeamSelectContainer").find('.draftPlayerManualInputSelect').val(''),
				this.$el.find("#draftPlayerManualFormPosSelectContainer").find('.draftPlayerManualInputSelect').val(''),
				this.event.trigger("draftNormalPlayerView");
				$('.draftPlayerTrigger').first().dropdown('toggle');
			}
		},
		
		errorCallback: function(error) {
			if(this.submittedData.isSubmitted){
				if (error.status == 400) {
					//Input errors
					this.event.trigger("error");
					
					var errObj = JSON.parse(error.responseText);
					
					if(errObj.code){
						for(var i=0; i< errObj.code.length; i++){
							if(errObj.code[i].indexOf("_") > 0){
								//Trigger a specific event for the field with the code attached as a param
								var errCode = errObj.code[i].substring(0, errObj.code[i].indexOf("_"));
								var field = errObj.code[i].substring(errObj.code[i].indexOf("_") + 1);
								this.event.trigger("error:" + field.toLowerCase(), errCode);
							}
						}
					}
				} else {
					this.event.trigger("error");					
				}
				
				this.submittedData.isSubmitted = false;
			}
		},
		
		updatePickSumId: function(event, pickSumId) {
			this.addedPickSumId = pickSumId;
		},
		
		returnToMain: function() {
			this.event.trigger("draftNormalPlayerView");
		},
		
		processing: function () {
			this.hideAll();
			this.$("#draftPlayerManualMessage").show();
			this.$("#draftPlayerManualMessageProcessing").show();
		},
		
		error: function () {
			this.hideAll();
			this.$("#draftPlayerManualMessage").show();
			this.$("#draftPlayerManualMessageError").show();
			this.$("#draftPlayerManualFormContainer").show();
		},
		
		showForm: function () {
			this.hideAll();
			this.$("#draftPlayerManualFormContainer").show();
		},
		
		hideAll: function() {
			this.$("#draftPlayerManualMessage").hide();
			this.$("#draftPlayerManualMessageError").hide();
			this.$("#draftPlayerManualMessageProcessing").hide();
			this.$("#draftPlayerManualMessageSuccess").hide();
			this.$("#draftPlayerManualFormContainer").hide();
			
			//Hide error messages			
			this.$("#draftPlayerManualFirstNameContainer span").css({"color": ""});
			this.$("#draftPlayerManualFirstNameInput").css({"border-color": "", "color": ""});
			this.$("#draftPlayerManualFirstNameInputErrMsg").hide();
			
			this.$("#draftPlayerManualLastNameInputContainer span").css({"color": ""});
			this.$("#draftPlayerManualLastNameInput").css({"border-color": "", "color": ""});
			this.$("#draftPlayerManualLastNameInputErrMsg").hide();
			
			this.$("#draftPlayerManualFormTeamSelectContainer span").css({"color": ""});
			this.$("#draftPlayerManualTeamSelectErrMsg").hide();
			
			this.$("#draftPlayerManualFormPosSelectContainer span").css({"color": ""});
			this.$("#draftPlayerManualPosSelectErrMsg").hide();
		},
		
		errorFirstName : function (errorCode) {
			this.$("#draftPlayerManualFirstNameContainer span").css({"color": "#a84846"});
			this.$("#draftPlayerManualFirstNameInput").css({"border-color": "#d79999", "color": "#a84846"});
			switch (errorCode){
				case "NULL": 
					this.$("#draftPlayerManualFirstNameInputErrMsg").html("First name is empty");
					this.$("#draftPlayerManualFirstNameInputErrMsg").show();
					break;
				case "LENGTH":
					this.$("#draftPlayerManualFirstNameInputErrMsg").html("First name must be between 1 and 20 characters long");
					this.$("#draftPlayerManualFirstNameInputErrMsg").show();
					break;
				case "Name":
					this.$("#draftPlayerManualFirstNameInputErrMsg").html("First name may only contain alpha numeric characters, spaces, dashes, periods, and apostrophes");
					this.$("#draftPlayerManualFirstNameInputErrMsg").show();
					break;
				default : 
					this.$("#draftPlayerManualFirstNameInputErrMsg").html("First name is invalid");
					this.$("#draftPlayerManualFirstNameInputErrMsg").show();
			}
		},
		
		errorLastName : function (errorCode) {
			this.$("#draftPlayerManualLastNameInputContainer span").css({"color": "#a84846"});
			this.$("#draftPlayerManualLastNameInput").css({"border-color": "#d79999", "color": "#a84846"});
			
			switch (errorCode){
				case "NULL": 
					this.$("#draftPlayerManualLastNameInputErrMsg").html("Last name is empty");
					this.$("#draftPlayerManualLastNameInputErrMsg").show();
					break;
				case "LENGTH":
					this.$("#draftPlayerManualLastNameInputErrMsg").html("Last name must be between 1 and 30 characters long");
					this.$("#draftPlayerManualLastNameInputErrMsg").show();
					break;
				case "Name":
					this.$("#draftPlayerManualLastNameInputErrMsg").html("Last name may only contain alpha numeric characters, spaces, dashes, periods, and apostrophes");
					this.$("#draftPlayerManualLastNameInputErrMsg").show();
					break;
				default : 
					this.$("#draftPlayerManualLastNameInputErrMsg").html("Last name is invalid");
					this.$("#draftPlayerManualLastNameInputErrMsg").show();	
			}	
		},
		
		errorTeamAbbr : function (errorCode) {
			this.$("#draftPlayerManualFormTeamSelectContainer span").css({"color": "#a84846"});
			switch (errorCode){
				case "NULL": 
					this.$("#draftPlayerManualTeamSelectErrMsg").html("Team is empty");
					this.$("#draftPlayerManualTeamSelectErrMsg").show();
					break;
				default : 
					this.$("#draftPlayerManualTeamSelectErrMsg").html("Team is invalid");
					this.$("#draftPlayerManualTeamSelectErrMsg").show();
			}
		},
		
		errorPos : function (errorCode) {
			this.$("#draftPlayerManualFormPosSelectContainer span").css({"color": "#a84846"});
			switch (errorCode){
				case "NULL": 
					this.$("#draftPlayerManualPosSelectErrMsg").html("Position is empty");
					this.$("#draftPlayerManualPosSelectErrMsg").show();
					break;
				default : 
					this.$("#draftPlayerManualPosSelectErrMsg").html("Position is invalid");
					this.$("#draftPlayerManualPosSelectErrMsg").show();
			}
		},
		
		render: function() {
			//Add dropdown options for all of the sport's teams
			//var sportTeamElHtml = '<select name="draftPlayerManualTeamSelect" class="draftPlayerManualInputSelect" style="width: 125px;float: right;margin-top: -5px;">'
			//	+ '<option value="" selected="true">Select One</option>';
			var sportTeamEl = $(this.el).find('#draftPlayerManualTeamSelect');
			
			var curSportsTeams = this.sportsTeams;
			var sportTeamKeys = _.keys(curSportsTeams);
			var sortedSportTeamKeys = _.sortBy(sportTeamKeys, function(key){ return key; }); 
				
			_.each(sortedSportTeamKeys, 
				function(key){
					var optionElHtml = '<option value="' + key + '">' + curSportsTeams[key] + '</option>';
					var optionEl = $(optionElHtml);
					sportTeamEl.append(optionEl);
				}
			);
			
			//sportTeamElHtml = sportTeamElHtml	+ '</select>';
			
			//var sportTeamEl = $(sportTeamElHtml);
			//$(this.el).find('#draftPlayerManualFormTeamSelectContainer').append(sportTeamEl);
			
			
			//Add dropdown options for all of the sport's positions
			var posArr = [];
			switch (this.leagueInstance.get('prodLeagueName')) {
			case 'NFL':
				posArr = [			          
				          {value:"QB", name:"Quarterback"},
				          {value:"WR", name:"Wide Receiver"},
				          {value:"TE", name:"Tight End"},
				          {value:"RB", name:"Running Back"},
				          {value:"FB", name:"Fullback"},
				          {value:"DE", name:"Defensive End"},
				          {value:"DT", name:"Defensive Tackle"},
				          {value:"NT", name:"Nose Tackle"},
				          {value:"LB", name:"Linebacker"},
				          {value:"CB", name:"Cornerback"},
				          {value:"S", name:"Safety"},
				          {value:"PK", name:"Place Kicker"},
				          {value:"P", name:"Punter"},
				          {value:"C", name:"Center"},
				          {value:"OT", name:"Offensive Tackle"},
				          {value:"OG", name:"Offensive Guard"},
				          {value:"LS", name:"Long Snapper"},
				          {value:"DEF", name:"Team Defense"},
				          {value:"HC", name:"Head Coach"}];

				break;
			case 'MLB':
				posArr = [
				          {value:"C", name:"Catcher"},
				          {value:"1B", name:"First Base"},
				          {value:"2B", name:"Second Base"},
				          {value:"SS", name:"Short Stop"},
				          {value:"3B", name:"Third Base"},
				          {value:"LF", name:"Left Field"},
				          {value:"CF", name:"Center Field"},
				          {value:"RF", name:"Right Field"},
				          {value:"OF", name:"Out Field"},
				          {value:"DH", name:"Designated Hitter"},
				          {value:"SP", name:"Starting Pitcher"},
				          {value:"RP", name:"Relief Pitcher"},
				          //{value:"P", name:"Pitcher"},
				          {value:"HC", name:"Head Coach"}];
				
				break;
			case 'NBA':
				posArr = [
				          {value:"PG", name:"Point Guard"},
				          {value:"SG", name:"Shooting Guard"},
				          //{value:"G", name:"Guard"},
				          {value:"SF", name:"Small Forward"},
				          {value:"PF", name:"Power Forward"},
				          //{value:"F", name:"Forward"},
				          {value:"C", name:"Center"},
				          {value:"HC", name:"Head Coach"}
				          ];
				break;
			case 'NHL':
				posArr = [
				          {value:"C", name:"Center"},
				          {value:"LW", name:"Left Wing"},
				          {value:"RW", name:"Right Wing"},
				          {value:"D", name:"Defense"},
				          {value:"G", name:"Goalie"},
				          {value:"HC", name:"Head Coach"}
				          ];
				break;
			default:
				break;
			}
			
			//var posElHtml = '<select name="draftPlayerManualPosSelect" class="draftPlayerManualInputSelect" style="width: 125px;float: right;margin-top: -5px;">'
			//	+ '<option value="" selected="true">Select One</option>';
			var posEl = $(this.el).find('#draftPlayerManualPosSelect');
			
			_.each(posArr, 
				function(pos){
					//posElHtml += '<option value="' + pos.value + '">' + pos.name + '</option>';
					var optionElHtml = '<option value="' + pos.value + '">' + pos.name + '</option>';
					var optionEl = $(optionElHtml);
					posEl.append(optionEl);
				}
			);
			
			//posElHtml = posElHtml	+ '</select>';
			
			//var posEl = $(posElHtml);
			//$(this.el).find('#draftPlayerManualFormPosSelectContainer').append(posEl);
		}
	});
	
	var SelectPlayerView = Backbone.View.extend({
		el: $("#draftPlayerPopup"),
		
		initialize: function(options) {
			this.submitPlayerBtn = this.$el.find("#draftPlayerFormSubmit");
			this.playerInput = this.$el.find("#playerSearchInput");
			this.playerBidInput = this.$el.find("#draftPlayerBidInput");
			this.playerManualBidInput = $("#draftPlayerManualBidInput");
			this.playerEntryContainer = this.$el.find("#selectPlayerEntries");
			
			this.user = options.user;
			this.pickCollection = options.pickCollection;
			this.pickSummaryCollection = options.pickSummaryCollection;
			this.playerList = options.playerList;
			this.leagueInstance = options.leagueInstance;
			this.draftStatus = options.draftStatus;
			this.posColors = options.posColors;
			this.sportsTeams = options.sportsTeams;
			this.rankAttr = this.leagueInstance.get('ranksEnabled') ? 'OVRRANK' : null;
			this.firstPlayerView = null;
			
			this.event = _.extend({}, Backbone.Events);
			
			this.listenTo(this.event, 'draftNormalPlayerView', this.draftNormalPlayerView);
			this.listenTo(this.event, 'draftManualPlayerView', this.draftManualPlayerView);
			
			this.playerEntryViews = [];
			this.addedPickSumId = 1001;
			
			_.bindAll(this, 'renderPlayerRanks');
			_.bindAll(this, 'playerDrafted');
			_.bindAll(this, 'updatePickSumId');
			_.bindAll(this, 'positionPopup');
			_.bindAll(this, 'keyUp');
			_.bindAll(this, 'draftNormalPlayerView');
			_.bindAll(this, 'draftManualPlayerView');
			
			this.listenTo(this.posColors, 'change', this.posColorsChanged);
			
			$(".draftPlayerTrigger").on("click", this.positionPopup);
			$("#selectPlayerManualEntryBtn").on("click", this.draftManualPlayerView);
			
			this.draftStatus.bind("change", this.playerDrafted, this);
			//$("input").keyup(this.renderPlayerRanks);
			$('#draftPlayerForm').on("keyup", this.keyUp);
			$(document).on('draftApp:addPickSum', this.updatePickSumId);
			
			if(this.leagueInstance.get('draftStatus') == 'PREDRAFT'){
				$(document).on('draftApp:playerPicked', this.playerDrafted);
				$(document).on('draftApp:playerUnpicked', this.playerDrafted);
			}		
			
			this.selectManualPlayerView = new SelectManualPlayerView({
				el: this.$("#draftPlayerManual"), 
				event: this.event,
				pickCollection: this.pickCollection,
				pickSummaryCollection: this.pickSummaryCollection,
				leagueInstance: this.leagueInstance,
				draftStatus: this.draftStatus,
				sportsTeams: this.sportsTeams});
			
			if(this.leagueInstance.isCommissioner(this.user.get('userName')) 
					&& (this.leagueInstance.get('prodLeagueName') == 'NHL' || this.leagueInstance.get('prodLeagueName') == 'MLB' 
						|| this.leagueInstance.get('id') ==  169772 || this.leagueInstance.get('id') == 170000 || this.leagueInstance.get('id') == 169981 || this.leagueInstance.get('id') == 171356 || this.leagueInstance.get('id') == 171357 || this.leagueInstance.get('id') == 174351 || this.leagueInstance.get('id') == 187766 //NFL Leagues that requested this ability
						|| this.leagueInstance.get('id') == 195376 || this.leagueInstance.get('id') == 196752 || this.leagueInstance.get('id') == 196754  || this.leagueInstance.get('id') == 217275 // 2021 NFL leagues
						|| this.leagueInstance.get('id') == 227724 // 2022 NFL leagues
						//|| this.user.get('userName').toUpperCase() == 'CLICKYUSER'
						|| this.user.get('userName').toUpperCase() == 'RUDEBOYCS'
						|| this.user.get('userName').toUpperCase() == 'SCHOPP'
						|| this.user.get('userName').toUpperCase() == 'CST2006'
						|| this.user.get('userName').toUpperCase() == 'XBPOPX'
						|| this.user.get('userName').toUpperCase() == 'DYLANRAUH') //Dylan Rauh requested manual player entry for all leagues he's commissioner of
					){
				$('#selectPlayerManualEntry').show();
			} else if (this.leagueInstance.get('id') ==  238275 || this.leagueInstance.get('id') ==  238271 || this.leagueInstance.get('id') ==  238512 || this.leagueInstance.get('id') ==  238513) {
				// Enable manual entry for all members
				$('#selectPlayerManualEntry').show();
			} else {
				$('#selectPlayerManualEntry').hide();
			}
			
			this.draftNormalPlayerView();			
		},
		
		render: function () {	
			if(this.leagueInstance.get('draftType') == 'AUCTION'){
				$('#draftPlayerManualBidBodyContentForm').show();
				$('#draftPlayerManualBidInput').removeClass("error");
				$('#draftPlayerManualBidErrMsg').hide();
				
				$('#draftPlayerBidBodyContentForm').show();
				$('#draftPlayerBidInput').removeClass("error");
				$('#draftPlayerBidErrMsg').hide();
			}
						
			this.renderPlayerRanks();
			return this;
		},
		
		draftNormalPlayerView: function () {
			$('#draftPlayerLoadingContent').hide();
			$('#draftPlayerContent').show();
			$('#draftPlayerManual').hide();
		},
		
		draftManualPlayerView: function() {
			$('#draftPlayerLoadingContent').hide();
			$('#draftPlayerContent').hide();
			$('#draftPlayerManual').show();
		},
		
		keyUp: function(e) {
			//Submit on enter otherwise update list
			var code = e.keyCode || e.which; 
			if (code  == 13) {               
				e.preventDefault();
				
				if(this.firstPlayerView){
					this.firstPlayerView.draftPlayer();
				}
				
				return false;
			} else {
				this.renderPlayerRanks();
			}
		},
	    
	    renderPlayerRanks: function() {
	    	this.firstPlayerView = null;
			this.removeAllPlayerEntries();
			this.playerEntryContainer.empty();
			this.addAllPlayerEntries();
			this.displayWarning();
		},
		
		positionPopup: function(event) {
			var width = $(document).width();
			var height = $(document).height();
			
			$('#draftPlayerPopup .dropdown-menu').css('top', event.pageY + 15);
			$('#draftPlayerPopup .dropdown-menu').css('right', width - event.pageX);
			
			//this.playerInput.focus();
			setTimeout(function() { $('#playerSearchInput').focus();}, 200);
		},
		
		playerDrafted: function() {
			this.playerInput.val('');
			this.playerBidInput.val(1);
			this.playerManualBidInput.val(1);
			$('#draftPlayerBidInput').removeClass("error");
			$('#draftPlayerManualBidInput').removeClass("error");
			$('#draftPlayerBidErrMsg').hide();
			$('#draftPlayerManualBidErrMsg').hide();
			
			this.renderPlayerRanks();
		},
		
		displayWarning: function() {
			var fantTeamId = this.draftStatus.get('draftingTeamId');
			
			if(this.leagueInstance.get('draftStatus') == 'PREDRAFT'){
				fantTeamId = this.pickSummaryCollection.get(this.addedPickSumId).get('fantasyTeamId');
			}
			
			var minRequired = this.draftStatus.get('teamMinPosRequired')[fantTeamId];
			
			if(minRequired > 0) {
				$('#selectPlayerMaxWarning').hide();
				
				var posString = this.draftStatus.get('allowedPositions')[fantTeamId].join();
				$('#selectPlayerMinWarningList').html(posString);
				$('#selectPlayerMinWarning').show();
			} else if(this.draftStatus.get('teamMaxedPositions')[fantTeamId].length > 0){
				$('#selectPlayerMinWarning').hide();
				
				var posString = this.draftStatus.get('teamMaxedPositions')[fantTeamId].join();
				$('#selectPlayerMaxWarningList').html(posString);
				$('#selectPlayerMaxWarning').show();
			} else {
				$('#selectPlayerMaxWarning').hide();
				$('#selectPlayerMinWarning').hide();
			}
			
			var posString = this.draftStatus.get('allowedPositions')[fantTeamId].join();
			$('#selectPlayerAllowedPositionsList').html(posString);
		},
		
		posColorsChanged: function() {
			this.renderPlayerRanks();
		},
		
		updatePickSumId: function(event, pickSumId) {
			this.addedPickSumId = pickSumId;
			this.playerBidInput.val(1);
			this.playerManualBidInput.val(1);
			this.renderPlayerRanks();
		},
		
		addPlayerEntry: function(player) {
			var view = new SelectPlayerEntryView({
				player: player, 
				draftStatus: this.draftStatus,
				leagueInstance: this.leagueInstance,
				pickCollection: this.pickCollection,
				pickSummaryCollection: this.pickSummaryCollection,
				posColors: this.posColors,
				addedPickSumId : this.addedPickSumId,
				draftStatus: this.draftStatus});
			
			this.playerEntryContainer.append(view.render().el);
			this.playerEntryViews[player.id] = view;
			return view;
		},
		
		removePlayerEntry: function(player) {
			this.playerEntryViews[player.id].destroyView();
			delete this.playerEntryViews[player.id];
		},
		
		addAllPlayerEntries: function() {
			var fantTeamId = this.draftStatus.get('draftingTeamId');
			
			if(this.leagueInstance.get('draftStatus') == 'PREDRAFT'){
				fantTeamId = this.pickSummaryCollection.get(this.addedPickSumId).get('fantasyTeamId');
			}
			
			var allowedPositions = this.draftStatus.get('allowedPositions')[fantTeamId];
			
			var sortedPlayers = [];
			if(this.playerInput.val() && this.playerInput.val() != ''){
				var lgAllowedPositions = this.leagueInstance.allowedPositions();
				sortedPlayers = this.playerList.searchDraftablePlayers(this.playerInput.val(), lgAllowedPositions);
			} else if(this.rankAttr){
				sortedPlayers = this.playerList.sortByRank(this.rankAttr, false, allowedPositions);
			} else {
				sortedPlayers = new Array();
			}
			
			//Charity NHL league allows quick manual entry duplicates in first 6 rounds
			if(this.leagueInstance.get('id') == 70119 && this.draftStatus.get('round') <= 6){
				if(this.playerInput.val() && this.playerInput.val() != ''){
					var lgAllowedPositions = this.leagueInstance.allowedPositions();
					sortedPlayers = this.playerList.searchDraftablePlayers(this.playerInput.val(), lgAllowedPositions, true);
					
					var tempSortedPlayers = ['G'];
					var moreSortedPlayers = this.playerList.searchDraftablePlayers(this.playerInput.val(), tempSortedPlayers, true);
					var tmp = _.union(moreSortedPlayers, sortedPlayers);
					sortedPlayers = tmp;
				} else {
					sortedPlayers = this.playerList.sortByRank(this.rankAttr, true, allowedPositions);
				}
			}
			
			for (var i = 0; i < 5 && i < sortedPlayers.length ; i++) {
				var view = this.addPlayerEntry(sortedPlayers[i], this.rankAttr);
				
				if(i == 0){
					this.firstPlayerView = view;
				}
			}
		},
		
		removeAllPlayerEntries: function() {
			_.each(this.playerEntryViews, function(view, key){
				this.playerEntryViews[key].destroyView();
				delete this.playerEntryViews[key];
			}, this);
		},
	});
	
	return SelectPlayerView;  
});